import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./DashboardUserStudent.scss"; // Import SCSS styles
import StudentImage from "../../Assets/Images/AIRobot.svg"; // Adjust the path based on the folder structure
import Papers from "./ImageforDashboardStudent/Paper.svg"; // Adjust the path based on the folder structure
import { ReactComponent as Arrowicon } from "./ImageforDashboardStudent/iconoir_arrow-up-tag.svg"; // Adjust the path based on the folder structure
import { ReactComponent as Arrowrighticon } from "./ImageforDashboardStudent/rightside_arrow-up-tag.svg"; // Adjust the path based on the folder structure
import { ReactComponent as Mark } from "./ImageforDashboardStudent/Mark.svg"; // Adjust the path based on the folder structure
import { ReactComponent as Time } from "./ImageforDashboardStudent/Time.svg"; // Adjust the path based on the folder structure
import Viedoimage from "./ImageforDashboardStudent/Rectangle 10.png"; // Adjust the path based on the folder structure
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { decode } from "../../Utils/encodeDecode";
import { ILoginResponse } from "../Login/ILogin";
import Pricingimage from "./ImageforDashboardStudent/icon.png"; // Adjust the path based on the folder structure
import Pricingthirdimage from "./ImageforDashboardStudent/iconpermium.png"; // Adjust the path based on the folder structure
import AvatarImage from "../../Assets/Images/Chatbot_Avatar.png";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import {
  Paper,
  LinearProgress,
  useTheme,
  useMediaQuery,
  Grid,
  SvgIcon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Container,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  Stack,
  Avatar,
} from "@mui/material";
import ReactECharts from "echarts-for-react";
import {
  clearDashboardChart,
  dashboardChart,
} from "../../Redux/Slices/DashboardChart/DashboardChart";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import ButtonField from "../../Components/Button/ButtonField";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import { useNavigate } from "react-router-dom";
import { pendingExamList } from "../../Redux/Slices/UserPackage/PendingExamListSlice";
import { clearListPracticeExamID } from "../../Redux/Slices/PracticeExam/ListPracticeExamIDSlice";
import { clearpendingPracticeExam } from "../../Redux/Slices/PendingPracticeExam/PendingPracticeExamSlice";
import { clearlistEvaluationPracticewritingExam } from "../../Redux/Slices/PracticeExam/ListEvaluationPracticewritingExamSlice";
import { clearEditStudentExamPracticeResponse } from "../../Redux/Slices/StudentExamPractice/EditStudentExamPracticeSlice";
import { Card } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import {
  Box,
  Modal,
  IconButton,
  Typography,
  CardContent,
  Button,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { CheckCircle } from "@mui/icons-material";
import { listUserPackage } from "../../Redux/Slices/UserPackage/ListUserPackageSlice";
import { AddSubscription } from "../../Redux/Slices/Subscription/AddSubscriptionSlice";
import { listSubscription } from "../../Redux/Slices/Subscription/ListSubscriptionSlice";
import AppBarnav from "../../Components/AppBar/AppBar";
import Menus from "../../Components/Menu/Menu";
import IconButtonField from "../../Components/Button/IconButtonField";
import Avatars from "../../Components/Avatar/Avatars";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { ReactComponent as Rightarrow } from "./ImageforDashboardStudent/Newrightarrow.svg";
import { ReactComponent as Newplay } from "./ImageforDashboardStudent/pase.svg";
import { ReactComponent as New } from "./ImageforDashboardStudent/Newplay.svg";
import ProgressCard from "./Progresscard";
import ActivityDashboard from "./ActivityDashboard";
import PerformanceTrendCard from "./PerformanceTrendCard";
import QuestionBankStatus from "./QuestionBankStatus";
import Performanceattandcard from "./Performancechatandcard";
import { listQuestionBank } from "../../Redux/Slices/NewDashboardAPI/ListQuestionBankSlice";
import { listRecentActivity } from "../../Redux/Slices/NewDashboardAPI/ListRecentActivitySlice";
import { listPrefmanceTrend } from "../../Redux/Slices/NewDashboardAPI/ListPrefmanceTrendSlice";
import { listQuestionType } from "../../Redux/Slices/QuestionType/ListQuestionTypeSlice";
import {
  listPerformance,
  ListPerformanceSlice,
} from "../../Redux/Slices/NewDashboardAPI/ListPerformanceSlice";
import { listDashboardprogress } from "../../Redux/Slices/NewDashboardAPI/ListDashboardprogressSlice";
import { listDailygoals } from "../../Redux/Slices/NewDashboardAPI/ListdailygoalsSlice";
import { Popover } from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { listdaycalculation } from "../../Redux/Slices/day_calculation/ListdaycalculationSlice";
import ChatbotPublic from "../../Components/ChatbotPublic/ChatbotPublic";
import ChatIcon from "@mui/icons-material/Chat";
import { clearChatbotPublicStatus } from "../../Redux/Slices/ChatbotPublic/ChatbotPublicSlicer";
import { dashboardweeklypref } from "../../Redux/Slices/DashboardData/Dashboardweeklypref";
import { failurelistSettingReset } from "../../Redux/Slices/Setting/ListSettingResetSlice";
import { listDashboardPerformenceTrend } from "../../Redux/Slices/QuestionType/ListDashboardPerformanceTrend";

const DashboardUserStudent = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [details, setDetails] = useState<ILoginResponse>({});

  useEffect(() => {
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, []);

  const name: any = details?.username;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    dispatch(dashboardChart());
  }, [dispatch]);

  const { data: DashboardCards } = useAppSelector(
    (state) => state.DashboardChart
  );

  const Dashboarduser: any = DashboardCards?.data;

 


  const loginResponse = useAppSelector((state) => state.LoginSlicer);
  
  const { data: pendingExamLists } = useAppSelector(
    (state) => state.PendingExamList
  );

  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );
  const { data: AddUserSliceLoading } = useAppSelector(
    (state) => state.AddCreategoalsSlice
  );

  const { data: Listdaycalculation } = useAppSelector(
    (state) => state.ListdaycalculationSlice
  );
  const Days: any = Listdaycalculation?.data;
  console.log(Days?.days_left);

  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
        ...user,
        index: index + 1,
      }))
    : [];

  useEffect(() => {
    dispatch(listUser());
    dispatch(listdaycalculation());
    dispatch(listQuestionBank());
    // dispatch(listQuestionType());
    dispatch(listDashboardPerformenceTrend());
    dispatch(listRecentActivity());
    dispatch(listDashboardprogress());
    dispatch(listPerformance({ period: null }));
    dispatch(listPrefmanceTrend({ questiontype_id: null }));
    dispatch(listUserPackage());
    dispatch(pendingExamList());
    sessionStorage.removeItem("pending_time");
    sessionStorage.removeItem("student_exam_id");
    sessionStorage.removeItem("sectionreexamId");
    sessionStorage.removeItem("sectionId");
    sessionStorage.removeItem("response");
    sessionStorage.removeItem("question_id");
    sessionStorage.removeItem("question_type");

    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, [dispatch]);

  useEffect(() => {
    dispatch(listDailygoals());
  }, [dispatch, AddUserSliceLoading]);
  useEffect(() => {
    dispatch(clearListPracticeExamID());
    dispatch(clearpendingPracticeExam());
    dispatch(clearlistEvaluationPracticewritingExam());
    dispatch(clearEditStudentExamPracticeResponse());
  }, [dispatch]);

  // is pending exam list popup
  const [openUnder, setOpenUnder] = useState(false); // Step 1

  const [openProfile, setOpenProfile] = useState(false); // Step 1
  const [openPricing, setOpenPricing] = useState(false); // Step 2
  const [openPendingExam, setOpenPendingExam] = useState(false); // Step 3
  const [opensubscriptionExam, setOpensubscriptionExam] = useState(false); // Step 3
  const [profileChecked, setProfileChecked] = useState(false); // Internal flow control
  const [pricingChecked, setPricingChecked] = useState(false);
   

  

  useEffect(() => {
    dispatch(dashboardweeklypref());
  }, [dispatch]);
  const { data: weeklyPref } = useAppSelector(
    (state) => state.DashboardweeklyprefSliceReducer
  );

  const weeklyTip = weeklyPref?.data?.recommendation || "No tip available.";
  // useLayoutEffect(() => {
  //   setOpenUnder(true);
  // }, [Dashboarduser?.is_subscribed]);

  useEffect(() => {
  if (Dashboarduser) {
    const popupFlag = localStorage.getItem("subscribepopupfalse");

    // If no flag stored AND user is not subscribed
    if (!popupFlag && Dashboarduser?.is_subscribed === false) {
      setOpensubscriptionExam(true);
      localStorage.setItem("subscribepopupfalse", "true");
    }else{
      setOpensubscriptionExam(false)
    }

  }
}, [Dashboarduser]);


  useLayoutEffect(() => {
    if (Dashboarduser?.subscription_status === "Subscription is expired") {
      setOpensubscriptionExam(false);
    }
    if (
      Dashboarduser?.is_subscribed === true ||
      Dashboarduser?.subscription_status === "Subscription is expired"
    ) {
      setOpenPricing(false);
    }
  }, [Dashboarduser?.is_subscribed, Dashboarduser?.subscription_status]);

  console.log(ListUserSliceLoading?.data, "user data");
  // / STEP 1: Check if profile is missing
  useEffect(() => {
    if (
      ListUserSliceLoading?.message === "No profile found" ||
      ListUser[0]?.yeargroup_country_map_id === null ||
      ListUser[0]?.yeargroup_country_map_id === "" ||
      ListUser[0]?.yeargroup_country_map_id === 0
    ) {
      setOpenProfile(true); // Open profile popup
    } else {
      setProfileChecked(true); // Skip to next step
    }
    //  if (Dashboarduser?.is_subscribed === "false") {
    //     setOpensubscriptionExam(true);
    //   }
  }, [ListUser, Dashboarduser?.is_subscribed, ListUserSliceLoading]);

  // STEP 2: When profile popup is closed, check subscription
  useEffect(() => {
    if (profileChecked && !openProfile) {
      if (
        Dashboarduser?.is_subscribed === false &&
        Dashboarduser?.subscription_status === "Subscription is expired"
      ) {
        setOpenPricing(false); // Open pricing popup
      } else if (Dashboarduser?.is_subscribed === false) {
        setOpenPricing(true); // Open pricing popup
      } else {
        setPricingChecked(true); // Skip to next step
      }
    }
  }, [profileChecked, openProfile, Dashboarduser]);

  // STEP 3: When pricing popup is closed, check for pending exams
  useEffect(() => {
    if (Dashboarduser) {
    const popupFlag = localStorage.getItem("pendingExamLists_popupfalse");

    if (pricingChecked && !openPricing) {
      if (!popupFlag && pendingExamLists?.status === true) {
        setOpenPendingExam(true); 
        localStorage.setItem("pendingExamLists_popupfalse", "true");
      }else{
        setOpenPendingExam(false); 
      }
    }
      }
  }, [pricingChecked, openPricing, pendingExamLists]);

  // video is list

  const [openvideo, setOpenvideo] = useState(false);

  const handleClosevideo = () => setOpenvideo(false);

  // video modal open
  const handleOpen = () => {
    setOpenvideo(true);
    setAnchorEl(null);
  };

  // video list
  const videoList = [
    {
      id: 1,
      title:
        "GATE EXAM Sample Quick Walkthrough - Abstract Reasoning - WA 2025",
      time: "11:03",
      url: "https://www.youtube.com/embed/_6nPzWtZQKs?si=-2BuDfDeBQ6DIo5N",
    },
    {
      id: 2,
      title:
        "GATE EXAM Sample Full Walkthrough - Reading Comprehension - WA 2025",
      time: "34:54",
      url: "https://www.youtube.com/embed/MuBpPJ7Mgns?si=1kR0POSP828pVmmk",
    },
    {
      id: 3,
      title: "GATE EXAM Sample Full Walkthrough - Writing - WA 2025",
      time: "23:26",
      url: "https://www.youtube.com/embed/Eg0Jo5tDtNE?si=migH1w7N_zdAhqj-",
    },
    {
      id: 4,
      title:
        "GATE EXAM Sample Full Walkthrough - Quantitative Reasoning - WA 2025",
      time: "52:53",
      url: "https://www.youtube.com/embed/nKkoTJrcMzY?si=XnCZCRBKtVw9aYoS",
    },

    {
      id: 5,
      title:
        "Dr Jags's Speech PQRST Technique | Everest Tutoring | Harrisdale & Thornlie",
      time: "02:55",
      url: "https://www.youtube.com/embed/6vLA62hq-HU?si=rGJC5DkbRR-FzLjZ", // you can replace this with a new one if needed
    },
    {
      id: 6,
      title: "ATAR Physics WACE 2023 Predictions PART 1!",
      time: "01:30",
      url: "https://www.youtube.com/embed/VzqBisvh52k?si=dgtVK23WKJyGDqGA", // you can replace this with a new one if needed
    },
    {
      id: 7,
      title: "ATAR Physics WACE 2023 Prediction PART 3!",
      time: "01:27",
      url: "https://www.youtube.com/embed/sdF8xtcVphQ?si=MCPE8Ft-NtWNLvKj", // you can replace this with a new one if needed
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const currentVideo = videoList[currentIndex];

  const handleNextvideo = () => {
    setCurrentIndex((prev) => (prev + 1) % videoList.length);
  };

  const handlePrevideo = () => {
    setCurrentIndex((prev) => (prev - 1 + videoList.length) % videoList.length);
  };

  const handleVideoSelect = (index: number) => {
    setCurrentIndex(index);
  };

  // Pricing  popup

  const { data: listUserPackageSlice } = useAppSelector(
    (state) => state.ListUserPackageSlice
  );
  const Packages: any = Array.isArray(listUserPackageSlice?.data)
    ? listUserPackageSlice?.data.map((user, index) => ({
        ...user,
        index: index + 1,
      }))
    : [];

  const { data: SubscriptionSlice, isLoading: scriptionSlice } = useAppSelector(
    (state) => state.ListSubscriptionSlice
  );
  const Subcriptiondetails: any = SubscriptionSlice;

  useLayoutEffect(() => {
    if (Subcriptiondetails?.status === true) {
      navigate("/subscribedPages");
    }
  }, [Subcriptiondetails]);

  // Popup

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isHoveringCard, setIsHoveringCard] = useState(false);
  const [isHoveringPopup, setIsHoveringPopup] = useState(false);
  const closeTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleCardEnter = (event: React.MouseEvent<HTMLElement>) => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setAnchorEl(event.currentTarget);
    setIsHoveringCard(true);
  };

  const handleCardLeave = (event: React.MouseEvent<HTMLElement>) => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setAnchorEl(event.currentTarget);
    setIsHoveringCard(false);
    setIsHoveringPopup(false);
    startCloseTimer();
  };

  const handlePopupEnter = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setIsHoveringPopup(true);
  };

  const handlePopupLeave = () => {
    setIsHoveringPopup(false);
    setAnchorEl(null);
    startCloseTimer();
  };

  const startCloseTimer = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => {
      if (!isHoveringCard && !isHoveringPopup) {
        setAnchorEl(null);
      }
    }, 300);
  };

  // const handleButtonClick = () => {
  //   alert("Platform Tutorial Clicked!");
  // };

  const open = Boolean(anchorEl);

  const [chatbotOpen, setChatbotOpen] = React.useState<boolean>(false);

  return (
    <>
      <div className="DashboardStudentAlingment">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div>
            <div
              className="DashboardStudent"
              style={{ fontWeight: "700", marginTop: "20px" }}
            >
              GATE AI Online Question Bank
            </div>
            <div className="StudentPractice">
              Track your GATE exam preparation progress on the Dashboard!
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Menus
              menuItems={[
                {
                  menu: "Logout",
                  onClick: () => {
                    sessionStorage.clear();
                    dispatch(clearListuser());
                    dispatch(clearLoginStatus());
                    dispatch(clearDashboardChart());
                    navigate("/login");
                  },
                },
              ]}
            >
              <IconButtonField onClick={() => {}}>
                <Avatars sx={{ height: "2rem", width: "2rem" }} />
              </IconButtonField>
            </Menus>

            {/* Username + SubscriptionStatus stacked vertically */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "8px",
                alignItems: "flex-start",
              }}
            >
              <span className="Username" style={{ padding: "0", margin: "0" }}>
                {ListUser[0]?.student_name}
              </span>
              {Dashboarduser?.is_subscribed ? (
                <span className="SubscriptionStatus" style={{ padding: "0" }}>
                  Premium
                </span>
              ) : (
                <span className="SubscriptionStatus" style={{ padding: "0" }}>
                  Free Plan
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="containerstudent">
          <div className="firststudent">
            <div className="customCardStudent">
              <div style={{ display: "flex" }}>
                <div className="textContentStudent">
                  <Typography variant="h5" className="textsytleheadingStudent">
                    Welcome back, {ListUser[0]?.student_name}!
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "16px",
                      color: "#FFFFFF",
                      marginBottom: "10px",
                      fontWeight: 400,
                    }}
                  >
                    Your next GATE exam is in{" "}
                    {Days?.days_left ? Days?.days_left : "0"} days. Ready to
                    continue your preparation?
                  </Typography>
                  <div className="hide-on-small">
                    <Button
                      variant="contained"
                      className="resetldashboard"
                      onClick={() => {
                        navigate("/examprogress");
                      }}
                    >
                      <SvgIcon
                        component={Newplay}
                        sx={{ marginRight: "15px", fill: "white" }}
                      />
                      Resume Last Session
                    </Button>
                    <Button
                      className="resetalldashboard"
                      onClick={() => {
                        navigate("/practicetest");
                      }}
                    >
                      Start New Practice
                      <SvgIcon
                        component={Rightarrow}
                        color="inherit"
                        sx={{ marginLeft: "15px" }}
                      />
                    </Button>
                  </div>
                </div>
              </div>
              <div className="weekly">
                <div
                  style={{
                    fontSize: "15px",
                    color: "#FFFFFF",
                    marginBottom: "5px",
                    fontWeight: 600,
                  }}
                >
                  WEEKLY TIP
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#FFFFFF",
                    fontWeight: 400,
                  }}
                >
                  {weeklyTip}
                </div>
              </div>
              {/* <img className="image" src={Papers} alt="Right Image" /> */}
            </div>
          </div>
          <div className="TwocardforDashboard">
            <div
              className="secondstudent"
              onMouseEnter={handleCardEnter}
              onMouseLeave={handleCardLeave}
            >
              <Box
                sx={{
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    maxWidth: 345,
                    width: "100%",
                    borderRadius: "5px",
                    position: "relative",
                    cursor: "pointer",
                    height: "100%",
                    background:
                      "linear-gradient(90deg, #2563eb 0%, #009dff 100%)", // <-- Linear gradient
                    boxShadow:
                      "rgba(0, 0, 0, 0.25) 0px 0px 10px,rgba(0, 0, 0, 0.12) 0px -1px 3px,rgba(0, 0, 0, 0.09) 0px -3px 5px",
                    "@media (max-width:1300px)": {
                      maxWidth: "none", // Remove maxWidth at 1300px+
                    },
                  }}
                >
                  <SvgIcon
                    component={New}
                    sx={{
                      fontSize: "50px",
                      color: "#009DFF",
                      position: "absolute",
                      top: "20%",
                      left: "40%",
                      "@media (max-width:1300px)": {
                        left: "48%", // Remove maxWidth at 1300px+
                      },
                    }}
                  />

                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      background: "white",
                      padding: "8px 12px",
                      boxSizing: "border-box",
                      color: "#fff",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                      borderRadius: " 0px 0px 5px 5px",
                    }}
                  >
                    <div>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: "bold",
                          color: "black",
                          fontSize: { xs: "1rem", md: "1.2rem" },
                        }}
                      >
                        Getting Started
                      </Typography>
                      <Typography
                        sx={{
                          color: "#6b7280",
                          fontSize: { xs: "1rem", md: "1.2rem" },
                        }}
                      >
                        Quick platform overview (2:15)
                      </Typography>
                    </div>
                    <KeyboardDoubleArrowRightIcon
                      onClick={() => {
                        navigate("/tutorials");
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </div>
          </div>
        </div>
        <Box sx={{ mt: 2, mb: 2 }}>
          {/* Chat Suggestion Box */}
          <Paper
            elevation={0}
            sx={{
              borderRadius: "10px",
              p: "24px",
              display: "flex",
              justifyContent: "space-between",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
              alignItems: "center",
              flexDirection: isMobile ? "column" : "row",
              gap: 2,
              margin: "0",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <div className="blinking-avatar-container1">
                <Avatar
                  src={AvatarImage}
                  alt="Profile"
                  className="blinking-avatar1"
                />
              </div>

              <Box>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "18px",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  Hey, I'm Elliot, your virtual assistant
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#424242" }}>
                  You can ask me anything related to your exam preparation.
                </Typography>
              </Box>
            </Stack>

            <Button
              variant="contained"
              sx={{
                borderRadius: "10px",
                fontWeight: 600,
                textTransform: "none",
                px: 3,
                py: 1,
                color: "white",
                fontSize: "15px",
                backgroundColor: "#009dff",
                "&:hover": {
                  backgroundColor: "#1976d2",
                },
              }}
              onClick={() => {
                setChatbotOpen(true);
                dispatch(clearChatbotPublicStatus());
              }}
            >
              ASK ELLIOT
            </Button>
          </Paper>
        </Box>
        {chatbotOpen && (
          <ChatbotPublic open={chatbotOpen} setOpen={setChatbotOpen} />
        )}

        {/* ------card design-- */}
        <ProgressCard />
        {/* ----- */}

        <Performanceattandcard />

        {/* --------two card -design -------- */}
        <ActivityDashboard />

        {/* -------graph line----- */}

        <PerformanceTrendCard />
        {/* ------QuestionBankStatus------ */}
        <br />
        <QuestionBankStatus />
        <br />
      </div>
      <button
        className="floating-chatbot-button "
        onClick={() => {
          setChatbotOpen(true);
          dispatch(clearChatbotPublicStatus());
        }}
      >
        <img
          src={AvatarImage}
          alt="Chat with Elliot"
          className="chatbot-avatar"
        />
      </button>

      <React.Fragment>
        <Dialog
          open={openUnder}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>
              {" "}
              Website Under Maintenance
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px" }}
            >
              Our website is currently undergoing an upgrade and is temporarily
              unavailable. Please try again after 24 hours. We appreciate your
              patience and understanding.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <button
              className="card-buttonexam"
              onClick={() => {
                navigate("/login");
                setOpenUnder(false);
              }}
            >
              ok
            </button>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      <React.Fragment>
        <Dialog
          open={openProfile}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>
              {" "}
              Please update Profile
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px" }}
            >
              Please update your profile/year level to ensure accurate exam
              assignment.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <button
              className="card-buttonexam"
              onClick={() => {
                navigate("/setting");
                setOpenProfile(false);
                setProfileChecked(true);
              }}
            >
              Update profile
            </button>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      <React.Fragment>
        <Dialog
          open={openPendingExam}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>Warning</div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px" }}
            >
              Your exam is in progress. Are you ready to continue?{" "}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <ButtonField
              className="form_save_button"
              onClick={() => {
                navigate("/examprogress");
                setOpenPendingExam(false);
              }}
            >
              Yes
            </ButtonField>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setOpenPendingExam(false)}
            >
              No
            </ButtonField>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      <React.Fragment>
        <Dialog
          open={opensubscriptionExam}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
              width: "30rem",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>Warning</div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px", textAlign: "center" }}
            >
              {Dashboarduser?.subscription_status}
            </DialogContentText>
          </DialogContent>

          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <ButtonField
              className="form_cancel_buttonsub"
              onClick={() => setOpensubscriptionExam(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_buttonssub"
              onClick={() => {
                // dispatch(AddSubscription());
                // dispatch(
                //   listSubscription({
                //     package_id: Packages[0]?.package_id,
                //   })
                // );
                setOpensubscriptionExam(false);
                setOpenPricing(true);
              }}
            >
              {Subcriptiondetails?.status === true
                ? "Loading..."
                : "Continue to Payment"}
            </ButtonField>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      {/* Modal for video */}

      <Modal open={openvideo}>
        {/* Video Area with Previews */}
        <>
          <Box sx={{ width: "100%", position: "relative" }}>
            <IconButton
              sx={{
                position: "absolute",
                top: 6,
                right: 38,
                m: 1, // optional: adds margin from edges
                color: "#FFFFFF",
                zIndex: 2,
                backgroundColor: "gray",
              }}
              onClick={handleClosevideo}
            >
              <CloseIcon
                sx={{ fontSize: "20px", color: "white", fontWeight: 600 }}
              />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
              width: "100%",
              height: "100%",
              mb: 2,
            }}
          >
            {/* Left Preview + Arrow */}
            <Box sx={{ width: "10%", position: "relative" }}>
              <IconButton
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translateY(-50%)",
                  color: "#FFFFFF",
                  zIndex: 2,
                }}
                onClick={handlePrevideo}
              >
                <ArrowBackIosNewIcon sx={{ fontSize: "50px" }} />
              </IconButton>
            </Box>

            {/* Center Main Video */}
            <Box sx={{ width: "80%" }}>
              <Box
                component="iframe"
                width="100%"
                src={`${currentVideo.url}?autoplay=1`}
                title={currentVideo.title}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
                sx={{ borderRadius: "20px", height: "60rem" }}
              />
            </Box>

            {/* Right Preview + Arrow */}
            <Box sx={{ width: "10%", position: "relative" }}>
              <IconButton
                sx={{
                  position: "absolute",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#FFFFFF",
                  zIndex: 2,
                }}
                onClick={handleNextvideo}
              >
                <ArrowForwardIosIcon sx={{ fontSize: "50px" }} />
              </IconButton>
            </Box>
          </Box>
        </>
      </Modal>

      <Dialog
        open={openPricing}
        PaperProps={{
          sx: {
            borderRadius: "20px",
            padding: "0px 0px 20px 0px",
            overflow: "visible",
            backgroundColor: "#F8F9FA",
            maxWidth: "100%",
            // maxHeight: { xs: "80vh", md: "90vh" },
          },
        }}
      >
        <DialogTitle sx={{ padding: "0px" }}>
          <div
            style={{
              backgroundColor: "#1196f4",
              borderRadius: "20px 20px 0px 0px",
              padding: "30px",
            }}
          >
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-end",
                marginTop: "-12px",
              }}
            >
              <ClearIcon
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenPricing(false);
                  setPricingChecked(true);
                }}
              />
            </div>
            <Typography
              textAlign="center"
              color="white"
              sx={{ color: "white", fontSize: "34px", fontWeight: 600 }}
            >
              Start Free. Upgrade Anytime.
            </Typography>
            <Typography
              variant="body2"
              textAlign="center"
              sx={{ color: "#dbeafe", fontSize: "20px", fontWeight: 400 }}
            >
              Choose the plan that works best for your preparation needs
            </Typography>
          </div>
        </DialogTitle>
        <DialogContent
          className="table-container"
          sx={{
            padding: "0px",
            backgroundColor: "white",
            borderRadius: "20px 20px 0px 0px",
          }}
        >
          <Grid
            item
            xs={12}
            md={10}
            justifyContent="center"
            sx={{ margin: "30px" }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: 4,
                justifyContent: "center",
                alignItems: "stretch",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <div className={`card-popup`}>
                  <Typography
                    variant="h5"
                    component="h3"
                    sx={{
                      fontWeight: "bold",

                      fontSize: "2rem",
                      color: "black",
                    }}
                  >
                    Free Plan
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "3rem",
                      color: "black",
                    }}
                  >
                    $0
                    <Typography
                      component="span"
                      variant="body2"
                      sx={{
                        fontSize: "17px",
                        fontWeight: "bold",
                        color: "#374151",
                        marginLeft: "10px",
                      }}
                    >
                      Forever
                    </Typography>
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 2,
                      color: "#374151",
                      fontSize: "17px",
                    }}
                  >
                    Perfect for trying out our platform.
                  </Typography>
                  {/* <Divider variant="middle" /> */}
                  <Box sx={{ mb: 4, mt: 2 }}>
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 600,
                        color: "black",
                        fontSize: "16px",
                        marginBottom: "10px",
                        marginTop: "30px",
                      }}
                    >
                      What's included:
                    </Typography>
                    <List dense sx={{ height: "15rem" }}>
                      <ListItem disablePadding sx={{ marginBottom: "10px" }}>
                        <ListItemIcon sx={{ minWidth: "30px" }}>
                          <CheckIcon sx={{ color: "green" }} />
                        </ListItemIcon>
                        <Typography sx={{ color: "black", fontSize: "16px" }}>
                          15 QR, AR & Reading Questions
                        </Typography>
                      </ListItem>
                      <ListItem disablePadding sx={{ marginBottom: "10px" }}>
                        <ListItemIcon sx={{ minWidth: "30px" }}>
                          <CheckIcon sx={{ color: "green" }} />
                        </ListItemIcon>
                        <Typography sx={{ color: "black", fontSize: "16px" }}>
                          1 AI-Marked Writing Task
                        </Typography>
                      </ListItem>

                      <ListItem disablePadding sx={{ marginBottom: "10px" }}>
                        <ListItemIcon sx={{ minWidth: "30px" }}>
                          <Box sx={{ color: "text.disabled", mr: 1 }}>
                            {" "}
                            <ClearIcon />
                          </Box>
                        </ListItemIcon>
                        <Typography
                          sx={{
                            color: "text.disabled",
                            fontSize: "17px",
                          }}
                        >
                          <del style={{ fontSize: "17px" }}>
                            Full Length Timed Mock Exams
                          </del>
                        </Typography>
                      </ListItem>
                      <ListItem disablePadding sx={{ marginBottom: "10px" }}>
                        <ListItemIcon sx={{ minWidth: "30px" }}>
                          <Box sx={{ color: "text.disabled", mr: 1 }}>
                            {" "}
                            <ClearIcon />
                          </Box>{" "}
                        </ListItemIcon>
                        <Typography
                          sx={{
                            color: "text.disabled",
                            fontSize: "17px",
                          }}
                        >
                          <del style={{ fontSize: "17px" }}>
                            {" "}
                            All AI Powered Skill Trainer Modules
                          </del>
                        </Typography>
                      </ListItem>
                      <ListItem disablePadding sx={{ marginBottom: "10px" }}>
                        <ListItemIcon sx={{ minWidth: "30px" }}>
                          <Box sx={{ color: "text.disabled", mr: 1 }}>
                            {" "}
                            <ClearIcon />
                          </Box>{" "}
                        </ListItemIcon>
                        <Typography
                          sx={{
                            color: "text.disabled",
                            fontSize: "17px",
                          }}
                        >
                          <del style={{ fontSize: "17px" }}>
                            Access to Newly Released Questions
                          </del>
                        </Typography>
                      </ListItem>
                    </List>
                  </Box>

                  <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    sx={{
                      fontSize: "1.2rem",
                      background: "#009DFF",
                      color: "white",
                      padding: "10px",
                      fontWeight: "bold",

                      textTransform: "capitalize",
                      borderRadius: "10px",
                      width: "100%", // 100% width on small screens

                      "&:hover": {
                        background: "#009DFF",
                        color: "white",
                      },
                    }}
                    onClick={() => {
                      navigate("/practicetest");
                    }}
                  >
                    Start Free
                  </Button>
                </div>
              </Box>
              <Box sx={{ flex: 1 }}>
                <div className={`card-containerpopup ${"line-cardpopup"}`}>
                  <Card className="card-containerpopup">
                    <Box
                      sx={{
                        position: "absolute",
                        top: "17px",
                        right: "10px",
                        background: " #6366f1",
                        color: "white",
                        px: 2.3,

                        fontSize: "1rem",
                        fontWeight: "bold",
                        borderRadius: "15px",
                      }}
                    >
                      RECOMMENDED
                    </Box>

                    <Typography
                      variant="h5"
                      component="h3"
                      sx={{
                        fontWeight: "bold",

                        fontSize: "2rem",
                        color: "black",
                      }}
                    >
                      Premium Plan
                    </Typography>
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "3rem",
                        color: "black",
                      }}
                    >
                      $9.69
                      <Typography
                        component="span"
                        variant="body2"
                        sx={{
                          fontSize: "17px",
                          fontWeight: "bold",
                          color: "#374151",
                          marginLeft: "10px",
                        }}
                      >
                        per week, billed monthly
                      </Typography>
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        mb: 2,
                        color: "#374151",
                        fontSize: "17px",
                      }}
                    >
                      Everything you need for GATE success.
                    </Typography>
                    {/* <Divider variant="middle" /> */}
                    <Box sx={{ mb: 4, mt: 2 }}>
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 600,
                          color: "black",
                          fontSize: "16px",
                          marginBottom: "10px",
                          marginTop: "30px",
                        }}
                      >
                        What's included:
                      </Typography>
                      <List dense sx={{ height: "15rem" }}>
                        <ListItem disablePadding sx={{ marginBottom: "10px" }}>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <CheckIcon sx={{ color: "green" }} />
                          </ListItemIcon>
                          <Typography sx={{ color: "black", fontSize: "16px" }}>
                            2000+ GATE Questions (QR, AR & Reading)
                          </Typography>
                        </ListItem>
                        <ListItem disablePadding sx={{ marginBottom: "10px" }}>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <CheckIcon sx={{ color: "green" }} />
                          </ListItemIcon>
                          <Typography sx={{ color: "black", fontSize: "16px" }}>
                            Unlimited Writing Prompts with AI Marking
                          </Typography>
                        </ListItem>
                        <ListItem disablePadding sx={{ marginBottom: "10px" }}>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <CheckIcon sx={{ color: "green" }} />
                          </ListItemIcon>
                          <Typography sx={{ color: "black", fontSize: "16px" }}>
                            Full Length Timed Mock Exams
                          </Typography>
                        </ListItem>
                        <ListItem disablePadding sx={{ marginBottom: "10px" }}>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <CheckIcon sx={{ color: "green" }} />
                          </ListItemIcon>
                          <Typography sx={{ color: "black", fontSize: "16px" }}>
                            All AI Powered Skill Trainer Modules
                          </Typography>
                        </ListItem>
                        <ListItem disablePadding sx={{ marginBottom: "10px" }}>
                          <ListItemIcon sx={{ minWidth: "30px" }}>
                            <CheckIcon sx={{ color: "green" }} />
                          </ListItemIcon>
                          <Typography sx={{ color: "black", fontSize: "16px" }}>
                            Access to Newly Released Questions
                          </Typography>
                        </ListItem>
                      </List>
                    </Box>
                    <Box sx={{ mt: 5 }}>
                      {Subcriptiondetails?.status === false ? (
                        <Button
                          variant="contained"
                          color="secondary"
                          size="large"
                          sx={{
                            fontSize: {
                              xs: "1rem",
                              sm: "1.1rem",
                              md: "1.2rem",
                            },
                            background: "#6366f1",
                            color: "white",
                            padding: { xs: "8px", sm: "10px" },
                            fontWeight: "bold",
                            textTransform: "capitalize",
                            borderRadius: "10px",
                            transition: "all 0.3s ease",
                            width: "100%",
                            minWidth: 0,
                            maxWidth: "100%",
                            boxSizing: "border-box",
                            mt: { xs: 2, md: 0 },
                            "&:hover": {
                              background: "#6366f1",
                              color: "white",
                            },
                          }}
                        >
                          Go Premium
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="secondary"
                          size="large"
                          sx={{
                            fontSize: {
                              xs: "1rem",
                              sm: "1.1rem",
                              md: "1.2rem",
                            },
                            background: "#6366f1",
                            color: "white",
                            padding: { xs: "8px", sm: "10px" },
                            fontWeight: "bold",
                            textTransform: "capitalize",
                            borderRadius: "10px",
                            transition: "all 0.3s ease",
                            width: "100%",
                            minWidth: 0,
                            maxWidth: "100%",
                            boxSizing: "border-box",
                            mt: { xs: 2, md: 0 },
                            "&:hover": {
                              background: "#6366f1",
                              color: "white",
                            },
                          }}
                          onClick={() => {
                            dispatch(AddSubscription());
                            dispatch(
                              listSubscription({
                                package_id: Packages[0]?.package_id,
                              })
                            );
                          }}
                        >
                          {Subcriptiondetails?.status === true
                            ? "Loading..."
                            : "Go Premium"}
                        </Button>
                      )}
                    </Box>
                  </Card>
                </div>
              </Box>
            </Box>
          </Grid>
        </DialogContent>
        <DialogContent
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <div
            className="pricingmaybelater"
            style={{
              color: "#4b5563",
              cursor: "pointer",
            }}
            onClick={() => {
              setOpenPricing(false);
              setPricingChecked(true);
            }}
          >
            Maybe Later
          </div>
          {Subcriptiondetails?.status === false ? (
            <Button
              className="pricingmaybelater"
              sx={{
                color: "white",
                width: "30%",
                fontWeight: "bold",
                backgroundColor: "#009DFF",
                cursor: "pointer",
              }}
              fullWidth
            >
              Continue to Payment
            </Button>
          ) : (
            <Button
              className="pricingmaybelater"
              sx={{
                color: "white",
                width: "30%",
                fontWeight: "bold",
                backgroundColor: "#009DFF",
                cursor: "pointer",
                "&:hover": {
                  background: "#009DFF",
                  color: "white",
                },
              }}
              fullWidth
              onClick={() => {
                dispatch(AddSubscription());
                dispatch(
                  listSubscription({
                    package_id: Packages[0]?.package_id,
                  })
                );
              }}
            >
              {Subcriptiondetails?.status === true
                ? "Loading..."
                : "Continue to Payment"}
            </Button>
          )}
        </DialogContent>
      </Dialog>

      <React.Fragment>
        <Dialog
          open={opensubscriptionExam}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
              width: "30rem",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>Warning</div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px", textAlign: "center" }}
            >
              {Dashboarduser?.subscription_status}
            </DialogContentText>
          </DialogContent>

          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <ButtonField
              className="form_cancel_buttonsub"
              onClick={() => setOpensubscriptionExam(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_buttonssub"
              onClick={() => {
                dispatch(AddSubscription());
                dispatch(
                  listSubscription({
                    package_id: Packages[0]?.package_id,
                  })
                );
                setOpensubscriptionExam(false);
              }}
            >
              {Subcriptiondetails?.status === true
                ? "Loading..."
                : "Continue to Payment"}
            </ButtonField>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      {/* Popover with Button */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => (setAnchorEl(null), setIsHoveringCard(false))}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          onMouseEnter: handlePopupEnter,
          onMouseLeave: handlePopupLeave,
          sx: {
            pointerEvents: "auto",
            width: 300,
            p: 0,
            borderRadius: 2,
            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: 150,
            cursor: "pointer",

            backgroundColor: "#f5f7fa",
          }}
          onClick={handleOpen}
        >
          <PlayCircleOutlineIcon sx={{ fontSize: 40, color: "#009EFF" }} />
        </Box>
        <Box sx={{ p: 2 }}>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            sx={{ fontSize: "18px" }}
          >
            Platform Tutorial
          </Typography>
          <Typography variant="body2" sx={{ fontSize: "14px" }}>
            Learn how to use all features of the GATE exam preparation platform
            to maximize your score.
          </Typography>
        </Box>
      </Popover>
    </>
  );
};

export default DashboardUserStudent;
